import request from '@/tools/request.js';
import {getHost, url} from "./link";
import store from '../store/index';
import ElementUI from 'element-ui';
import router from '../router';

let req = new request({
    host: getHost(),
    formatUrlencode: false
});

req.errFilter((obj) => {

});

let unuseQuery = [

]

function buildUrl(url, arg){

    if(typeof arg == 'object') {

        Object.keys(arg).forEach(k => {
            let rep = '{' + k + '}';
            if(url.indexOf(rep) != -1){
                url = url.replace(rep, arg[k]);
            }
        })
    }
    return url;
}


req.reqFilter((req) => {

    req.url = buildUrl(req.url, req.data);
    if(req.url.indexOf('{') != -1){
        debugger
    }
});

req.resFilter((res, xhr) => {
    res = JSON.parse(xhr.responseText);

    return res;
});

export default req;
